module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-card', [_c('el-alert', {
    attrs: {
      "title": "优惠券创建说明",
      "type": "info",
      "description": "展示方式分两种 1：组合（只需要上传一个优惠券图【组合】图片，每个优惠券不用上传图片）2：单个优惠券展示（不用上传优惠券组【合图】图片，在每个优惠券上单独上传图片）。建议展示方式选择 【组合图片展示】\n            活动关键字说明：填写后会根据关键字跳转到搜索商品列表中",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动banner",
      "hide-requied-aterisk": "true"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('a', 0)
      }
    }
  }, [(_vm.form.banner) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.banner
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入活动名称"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "活动时间"
    },
    model: {
      value: (_vm.form.activity_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_time", $$v)
      },
      expression: "form.activity_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示方式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.show_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_type", $$v)
      },
      expression: "form.show_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("组合图片展示 ")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("单个优惠券展示")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠券图【组合】"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('b', 0)
      }
    }
  }, [(_vm.form.cards_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.cards_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动关键字"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "活动关键字"
    },
    model: {
      value: (_vm.form.key_words),
      callback: function($$v) {
        _vm.$set(_vm.form, "key_words", $$v)
      },
      expression: "form.key_words"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "活动说明"
    },
    model: {
      value: (_vm.form.activity_explain),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_explain", $$v)
      },
      expression: "form.activity_explain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "线上优惠券"
    }
  }, [_vm._l((_vm.form.rule), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": '线上优惠券.' + (index + 1),
        "prop": 'rule.' + index + '.value',
        "rules": _vm.rules
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择优惠券",
        "filterable": ""
      },
      on: {
        "change": function($event) {
          return _vm.changeCard(index)
        }
      },
      model: {
        value: (item.card_id),
        callback: function($$v) {
          _vm.$set(item, "card_id", $$v)
        },
        expression: "item.card_id"
      }
    }, _vm._l((_vm.cardList), function(v, i) {
      return _c('el-option', {
        key: v.card_id,
        attrs: {
          "label": v.title,
          "value": v.card_id
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('card', index)
        }
      }
    }, [(item.img) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.img
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "text"
      },
      model: {
        value: (item.info),
        callback: function($$v) {
          _vm.$set(item, "info", $$v)
        },
        expression: "item.info"
      }
    }), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeRule(item)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addRule
    }
  }, [_vm._v("+线上优惠券")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "线下优惠券"
    }
  }, [_vm._l((_vm.form.rule2), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": '线下优惠券.' + (index + 1),
        "prop": 'rule2.' + index + '.value',
        "rules": _vm.rules2
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择优惠券",
        "filterable": ""
      },
      on: {
        "change": function($event) {
          return _vm.changeCard2(index)
        }
      },
      model: {
        value: (item.id),
        callback: function($$v) {
          _vm.$set(item, "id", $$v)
        },
        expression: "item.id"
      }
    }, _vm._l((_vm.cardList2), function(v, i) {
      return _c('el-option', {
        key: v.id,
        attrs: {
          "label": v.apprange_name,
          "value": v.id
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('xxcard', index)
        }
      }
    }, [(item.img) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.img
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "text"
      },
      model: {
        value: (item.info),
        callback: function($$v) {
          _vm.$set(item, "info", $$v)
        },
        expression: "item.info"
      }
    }), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeRule2(item)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addRule2
    }
  }, [_vm._v("+线下优惠券")])], 2), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.copy_flag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(" 复制活动 ")]) : _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(" 确定 ")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5827a7b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5827a7b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/cardticket/couponActivityedit.vue
// module id = 2734
// module chunks = 0